/*
	Optus App will view the first OCA page with ?src=app, we then set the cookie based on this url param.
*/

define(
	'Core/appRequest',[
		'jquery'
	],
	function($) {

		return {

			appRequestSrcValue: 'app',
			appRequestCookieName: 'isAppRequest',
			appRequestUrlParam: 'src',

			run: function(urlParamString) {
				var self = this,
					windowUrl = urlParamString || window.location.href;


				$(function () {
					if ($.getUrlParams) {
						var appRequest = $.getUrlParams(windowUrl)[self.appRequestUrlParam];
						if (typeof appRequest !== 'undefined') {
							if (appRequest === self.appRequestSrcValue) {
								$.setCookie(self.appRequestCookieName, 'true');
							} else {
								$.eraseCookie(self.appRequestCookieName);
							}
						}
					}
				});

				return self;

			}
		};

	}
);
